import React, { useState } from 'react';
import { EaseDrawer } from "../../../libs/EaseDrawer";
import { Text1, Text4, Text3 } from "../../../styles";
import { Descriptions, Button,Table, Badge } from "antd";
import { handleApiExceptions, alertify, generate_query_set } from '../../../app_methods';
import './index.scss';
import { PermissionHoc } from '../../HOC';
import { printRupee } from '../../../app_methods';
import { APPROVAL_FLOW_STATUS_TYPES } from '../../../constants';
import moment from 'moment';
import { TransferInfo } from '../../Transfers/List/info';
import { method } from 'lodash';
import { TransferRequest } from '../../../models';

const WritePermissableButton = PermissionHoc(Button,"APPROVAL_FLOW_WRITE",{ is_component: true, fallbackComponent: null })

const ApprovalDetailsDrawer = (props) => {
    const { approvalRequest } = props;
    const [showTransferInfoDrawer, setShowTransferInfoDrawer] = React.useState(false);
    const [isCancelling, setIsCancelling] = useState(false);
   

    const toggleTransferInfoDrawer = () => {
        setShowTransferInfoDrawer(!showTransferInfoDrawer);
    }

    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>Approval Details</Text1>
            </div>
        )
    };

    const cancelTransfer = async (record) => {
        setIsCancelling(true);
        const transfer_request = new TransferRequest(record);
        const response = await transfer_request.cancel()
        if (!response.success) {
            setIsCancelling(false);
            handleApiExceptions(response);
            return;
        }
        alertify("Success", "Transfer cancelled successfully.", "success");
        setIsCancelling(false);
        props.fetchTransferApprovals();
    }

    const renderBasicDetails = () => {  
        return (
        <>  <div>
            <Text3 strong>Basic Details
                 {!props.isMerchant && approvalRequest.approved_levels? !approvalRequest.approved_levels.includes(props.user_level) && !approvalRequest.declined_levels.includes(props.user_level) && !['approved', 'rejected','cancelled'].includes(approvalRequest.status) &&
                     <div style={{float: 'right'}}>      
                     <WritePermissableButton size="small"  className="mr-1" type="primary" onClick={() => props.onApprove(props.approvalRequest, false)} disabled={props.loading} >Approve</WritePermissableButton>
                     <WritePermissableButton size="small" className="mr-1" type="danger" onClick={() => props.onApprove(props.approvalRequest, true)} disabled={props.loading}>Reject</WritePermissableButton>
                     </div>
                 : null }
            </Text3>
            </div>
            <Descriptions className="mb-4 mt-2" title="" column={1} size="small" bordered>
                <Descriptions.Item label="Transfer Request URN">{approvalRequest.transfer_request? <Button size="small" type="link" onClick={toggleTransferInfoDrawer}>{approvalRequest.transfer_request.unique_request_number}</Button> || "---": '---'}</Descriptions.Item>
                <Descriptions.Item label="Amount">{printRupee(approvalRequest.amount) || "---"}</Descriptions.Item>
                <Descriptions.Item label="Requested By">{approvalRequest.requested_by}</Descriptions.Item>
                {
                    approvalRequest.transfer_request ?
                        approvalRequest.transfer_request.beneficiary_upi_handle ?
                            <Descriptions.Item label="UPI Handle">{approvalRequest.transfer_request.beneficiary_upi_handle || "---"}</Descriptions.Item>
                            :
                            <>
                                <Descriptions.Item label="Account Number">{approvalRequest.transfer_request.beneficiary_account_number || "---"}</Descriptions.Item>
                                <Descriptions.Item label="IFSC Code">{approvalRequest.transfer_request.beneficiary_account_ifsc || "---"}</Descriptions.Item>
                                <Descriptions.Item label="Bank Name">{approvalRequest.transfer_request.beneficiary_bank_name || "---"}</Descriptions.Item>
                            </>
                        :null
                }
                <Descriptions.Item label="Status">
                    {approvalRequest.status && <Badge color={APPROVAL_FLOW_STATUS_TYPES[approvalRequest.status].color} text={<Text4>{APPROVAL_FLOW_STATUS_TYPES[approvalRequest.status].label}</Text4>} />}
                 </Descriptions.Item>
            </Descriptions>
        </>
        )
    };

    const renderApprovedTable = () => {
        const columns = [
            {
              title: 'Name',
              key: 'name',
              render: (record) => <div>{record.name}</div>
            },
            {
              title: 'Email',
              key: 'email',
              render: (record) => <div>{record.email || "---"}</div>
            },
            {
                title: 'Level',
                key: 'level',
                render: (record) => <div>{record.level || "---"}</div>
              },
              {
                title: 'Overidden',
                key: 'overidden',
                render: (record) => <div>{record.overriden_by? "Yes": "No"}</div>
              },
              {
                title: 'Action',
                key: 'action',
                render: (record) => <div>{record.declined? "Rejected": "Approved"}</div>
              },
              {
                title: 'Action Time',
                key: 'approved_at',
                render: (record) => <div>{!record.declined? moment(record.approved_at).format("lll"): moment(record.declined_at).format("lll")}</div>
              },
          ];
          return (
          <>
              <Text3 strong>Approvals</Text3>
              <Table
                className="mb-4  mt-2 border-top border-left border-right rounded"
                columns={columns}
                dataSource={approvalRequest.approvals}
                bordered={false}
                size="middle"
                pagination={false}
              />
      </>
      )

    }
    


    return (
        <EaseDrawer
            className="merchant-details-wrapper"
            title={false}
            width={approvalRequest.approvals? approvalRequest.approvals.length >0 ? "45%": "25%" :"25%"}
            visible={props.visible}
            onClose={props.toggleDetailsDrawer}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            <div className="mt-3">
                {renderTitle()}
                {renderBasicDetails()}
                {approvalRequest.approvals? approvalRequest.approvals.length >0 ? renderApprovedTable(): null :null}
            </div>
            <TransferInfo
                visible={showTransferInfoDrawer}
                onClose={toggleTransferInfoDrawer}
                transferRequest={approvalRequest.transfer_request}
                cancelTransfer={cancelTransfer}
                merchant={props.merchant}
                isCancelling={isCancelling}
                showCancel={false}
                showQuery={false}
                
            />
        </EaseDrawer>
    )
};

export { ApprovalDetailsDrawer };